<div class="card">
    <div class="card-body">
        <div class="row">
            <div class="col-sm-5 col-12">
                <h6 class="mb-0">Instituição Credenciada</h6>
                <p>{{documentoPac?.codigoFnameCredenciada}} - {{documentoPac?.nomeInstituicaoCredenciada}}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-5 col-12">
                <h6 class="mb-0">Condição Operacional</h6>
                <p>{{documentoPac?.condicaoOperacional || '-'}}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-5 col-12">
                <h6 class="mb-0">Programa/Subprograma</h6>
                <p>{{ documentoPac?.programaNome || '-'}} - {{ documentoPac?.linhaNome || '-'}}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3 col-12">
                <h6 class="mb-0">Número da Proposta</h6>
                <p>{{documentoPac?.propostaNumero || '-'}}</p>
            </div>
            <div class="col-sm-3 col-12">
                <h6 class="mb-0">Número da PAC</h6>
                <p>
                    {{(numeroPacToString | bnMask: '99.999-9') || '-'}} 
                </p>
            </div>
            <div class="col-sm-3 col-12">
                <h6 class="mb-0">Sistemática</h6>
                <p>{{documentoPac?.tipoSistematica || '-'}}</p>
            </div>
            <div class="col-sm-3 col-12">
                <h6 class="mb-0">Situação</h6>
                <p>
                    {{documentoPac?.situacaoNomeInterno}} - {{documentoPac?.situacaoNomeExterno}}
                </p>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3 col-12">
                <h6 class="mb-0">Protocolo</h6>
                <p>{{(documentoPac?.dataProtocolo | date: 'dd/MM/yyyy') || '-'}}</p>
            </div>
            <div class="col-sm-3 col-12">
                <h6 class="mb-0">Aprovação</h6>
                <p>
                    {{(documentoPac?.dataAprovacao | date: 'dd/MM/yyyy') || '-'}}
                </p>
            </div>
            <div class="col-sm-3 col-12">
                <h6 class="mb-0">Valor Financiado (R$)</h6>
                <p>{{(documentoPac?.valorFinanciadoFname || 0) | bnMask: 'MOEDA'}}</p>
            </div>
            <div class="col-sm-3 col-12">
                <h6 class="mb-0">Valor próximos PLs (R$)</h6>
                <p title="Valor próximos PLs">
                    {{(valorProximosPls || 0) | bnMask: 'MOEDA'}}
                </p>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-3 col-12">
                <h6 class="mb-0">Ano do CE</h6>
                <p>{{documentoPac.anoCe || '-'}}</p>
            </div>
            <div class="col-sm-3 col-12">
                <h6 class="mb-0">Número do CE</h6>
                <p>
                    {{documentoPac.numeroCe || '-'}}
                </p>
            </div>
        </div>
    </div>
</div>
